import { MspEdrTrialReportView } from '../view/MspEdrTrialReportView';
import { templateMspEdrTrialReport } from '../view/template';
import { BaseWebComponentController } from '../../framework/BaseWebComponentController';
import { MspEdrTrialReportWebComponent } from '../component/MspEdrTrialReportWebComponent';
import { EdrTrialReportData } from '@nirvana/shared/dtos/types/dashboards/common';

export class MspEdrTrialReportController extends BaseWebComponentController {
  public component: MspEdrTrialReportWebComponent;
  public view: MspEdrTrialReportView;
  public viewConstructor: typeof MspEdrTrialReportView;

  constructor(component: MspEdrTrialReportWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MspEdrTrialReportView,
      viewTemplate: templateMspEdrTrialReport,
    });
  }

  async getDataForView(): Promise<EdrTrialReportData> {
    return this.component.edrTrialReportData;
  }
}